
import { Pipe, PipeTransform } from '@angular/core';
import Autolinker from 'autolinker';

@Pipe({ name: 'autolinker' })
export class AutolinkerPipe implements PipeTransform {
  transform(value: string, options?: any): string {
    return Autolinker.link(value, options);
  }
}
